<template>
  <div>

    <div class="table-responsive graph-container">
      <apexchart ref="chart" type="line" :height="height" :options="chart.options" :series="chart.series"></apexchart>
    </div>

  </div>
</template>
<script>
  import Widget from '@/components/Widget/Widget';
  import { mapState } from "vuex";

  export default {
  name: 'Loader',
  components: { Widget },
  props: {
    data: {type: Array, default: function(){return []}},
    pad: {type: Number, default: 0},
    height: {type: Number, default: 160},
    subtitle: {type: String, default: ''},
    hideXLabels: {type: Boolean, default: false},
    hideYLabels: {type: Boolean, default: false},
    clickable: {type: Boolean, default: false},
    routeName: {type: String, default: ''},
    units: {type: String, default: ''},
    options: {type: Object, default: function(){ return {} }},
  },
  data(){
    return {
      categories:[],
      chart:{
        series: [],
        options: {
          subtitle:{
            text: this.subtitle,
            style:{
              fontSize: '14px',
              color: 'gray'
            }
          },
          markers:{
            size: 6,
          },
          annotations:{
            xaxis:[ ]
          },
         chart: {
            type: 'line',
            height: this.height,
            toolbar: {
              show: false
            },
           zoom:{
              enabled:false,
           },
            events:{
              click:(event, chartContext, config)=>{
                if (config.dataPointIndex >= 0) {

                  if (this.categoryParams.length > 0 && this.categoryParams[config.dataPointIndex]){
                    if (this.routeName){
                      this.$router.push({name: this.routeName, query: {c: this.categoryParams[config.dataPointIndex]}})
                    }
                    else {
                      this.$router.push({query: {c: this.categoryParams[config.dataPointIndex]}})
                    }
                  }

                  // this.chart.options.annotations.xaxis[0].x = this.categories[config.dataPointIndex];
                  // this.chart.options.annotations.xaxis[0].label.text = this.$moment(new Date(this.data[config.dataPointIndex].started_at).getTime()).format('hh:mma');
                  // this.$refs.chart.updateOptions({...this.chart.options})
                  // this.$router.push({query: {c: this.data[config.dataPointIndex].crawl}});
                }
              },
              dataPointMouseEnter: (event) => {
                if (this.clickable){
                  event.path[0].style.cursor = "pointer";
                }

              }
            },
          },
          stroke: {
            width: 2,
            curve: 'straight'
          },
          tooltip:{
            enabled: true,
            intersect: true,
            shared: false,
            x:{
              show: false,
            },
            marker:{
              show: false
            },

            // fixed:{
            //   enabled: false,
            // }
          },
          yaxis:{
            show: !this.hideYLabels,
            tickAmount: 1,
            labels: {
              formatter: (v) => {
                if (this.units === 'ms'){
                  return v.toFixed(0) + 'ms';
                }
                if (this.units === 'size'){
                  return this.$options.filters.bytes(v);
                }
                return v
              }
            }
          },
          xaxis: {
            type: 'category',
            categories: [
            ],
            labels:{
              show: !this.hideXLabels,
              rotate:0,
            },
            // labels: {
            //   formatter: (value)=> {
            //     // return  [this.$moment(value).format('MMM D hh:mm')];
            //     return  [this.$moment(value).format('MMM D'), this.$moment(value).format('hh:mm')];
            //   }
            // }
          },

          legend: {
            position: 'bottom',
          },
          fill: {
            opacity: 1
          },
          dataLabels: {
            enabled: false
          },
        },
      },
      completed: false,
      showModal: this.show,
      error: '',
      subscription: {},
      submitting: false,
    }
  },
  methods: {
  },
  computed: {
    ...mapState({  user: "user" }),
  },
  mounted() {
    this.submitting = false;

    let series = [];
    this.categories = [];
    this.categoryParams = [];
    if (!this.options.categoryParams){
      this.options.categoryParams = [];
    }
    for (let entry of this.options.series) {
      series.push({name: entry.name, data:[...entry.data]})
    }
    for (let entry of this.options.categories) {
      this.categories.push([this.$moment(entry).format('MMM D,  h:mm a')])
    }
    for (let entry of this.options.categoryParams) {
      this.categoryParams.push(entry)
    }
    // this.categories = [];
    let xannotations = [];

    let start_time = this.$moment(this.options.categories[0]).subtract(0, 'days');
    if (this.pad){
      let padSize = this.pad - this.categories.length;
      for (let i=0; i<padSize; i++){
        start_time = start_time.subtract(1, 'days');
        this.categories.unshift([start_time.format('MMM D')]);
        this.categoryParams.unshift(null);
        for (let serie of series){
          serie.data.unshift(0);
        }
      }

    }
    this.chart.options.xaxis.categories = this.categories;
    this.$refs.chart.updateOptions({...this.chart.options})
    this.$refs.chart.updateSeries(series)
    // this.categories = [];
    // let xannotations = [];
    // for (let entry of this.data){
    //   for (let serie of series){
    //     serie.data.push(entry.data[serie.name] || 0)
    //   }
    //   if (entry.started_at) {
    //     this.categories.push([this.$moment(new Date(entry.started_at).getTime()).format('MMM D')]);
    //   }
    //   else{
    //     this.categories.push(['-'])
    //   }
    // }
    //
    // this.chart.options.xaxis.categories = this.categories;
    //
    // xannotations.push({
    //   x:this.categories[this.categories.length-1],
    //   fillColor: '#00E396',
    //   label:{
    //     orientation: 'horizontal',
    //     style: {
    //       color: 'rgba(13,30,35,0.43)',
    //     },
    //     text: this.$moment(new Date(this.data[this.categories.length-1].started_at).getTime()).format('hh:mma')
    //   }
    // } );
    // this.chart.options.annotations.xaxis = xannotations;
    // this.$refs.chart.updateOptions({...this.chart.options})
    // this.$refs.chart.updateSeries(series);
  },
}
</script>

<style src="./TrendGraph.scss" lang="scss"/>
